import { FC, useEffect } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { getAllSkills } from '../../graphQLOperations/Skills';
import { SkillsAllSkillsQuery } from '../../graphQLOperations/__generated__/SkillsAllSkillsQuery.graphql';
import { AncestriesRelevanceIds } from '../SkillsTable/SkillsTable';
import { removeHighlight } from '../../utils/removeSearchHighlight';
import { Skill } from '../../models/Skill';

const SUGGESTION_LIMIT = 10;

interface Props {
  searchQuery: string;
  onResults: (skills: Skill[]) => void;
}

export const SkillSearchResults: FC<Props> = ({ searchQuery, onResults }) => {
  const { searchSkills } = useLazyLoadQuery<SkillsAllSkillsQuery>(
    getAllSkills,
    {
      searchQuery,
      ancestriesIds: [AncestriesRelevanceIds.ESSENTIAL, AncestriesRelevanceIds.HELPFUL],
      first: SUGGESTION_LIMIT,
      last: null,
      skip: false,
      after: undefined,
      before: undefined,
    },
    { fetchPolicy: 'network-only', fetchKey: searchQuery },
  );

  useEffect(() => {
    const nodes = searchSkills?.nodes ?? [];

    onResults(
      nodes
        .filter((node): node is NonNullable<typeof node> => node !== null)
        .map(node => ({
          id: node.id,
          name: removeHighlight(node.name ?? ''),
          code: removeHighlight(node.code ?? ''),
        })),
    );
  }, [searchSkills, onResults]);

  return null;
};
